<template>
  <main-template>
    <v-row align="center" class="mb-1">
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="$router.go(-1)">
            <v-icon left>fa fa-angle-left</v-icon>
          </v-btn>
          Gerenciar Registros Remotos
        </h1>
      </v-col>
      <v-col cols="auto">
        <v-chip v-if="totalPendentes > 0" color="warning" dark small>
          {{ totalPendentes }} pendente{{ totalPendentes !== 1 ? "s" : "" }}
        </v-chip>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-tabs v-model="aba" background-color="transparent">
        <v-tab>
          Pendentes
          <v-badge
            v-if="totalPendentes > 0"
            :content="totalPendentes"
            color="warning"
            inline
            class="ml-1"
          />
        </v-tab>
        <v-tab>Histórico</v-tab>
      </v-tabs>

      <v-divider />

      <v-tabs-items v-model="aba">
        <v-tab-item>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headersPendentes"
              :items="pendentes"
              :loading="carregando"
              no-data-text="Nenhum registro remoto pendente"
              loading-text="Carregando..."
              class="cursor-pointer"
              @click:row="abrirDetalhe"
            >
              <template #[`item.colaborador`]="{ item }">
                {{ item.colaborador?.name || "—" }}
              </template>
              <template #[`item.data`]="{ item }">
                {{ formatarData(item.data) }}
              </template>
              <template #[`item.hora`]="{ item }">
                {{ formatarHora(item.hora) }}
              </template>
              <template #[`item.tipo_batida`]="{ item }">
                {{ formatarTipo(item.tipo_batida) }}
              </template>
              <template #[`item.created_at`]="{ item }">
                {{ formatarDataHora(item.created_at) }}
              </template>
              <template #[`item.acoes`]="{ item }">
                <v-btn
                  icon
                  small
                  color="primary"
                  title="Avaliar solicitação"
                  @click.stop="abrirDetalhe(item)"
                >
                  <v-icon small>mdi-gavel</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>

        <v-tab-item>
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headersHistorico"
              :items="historico"
              :loading="carregando"
              no-data-text="Nenhuma batida remota avaliada"
              loading-text="Carregando..."
              @click:row="abrirDetalhe"
            >
              <template #[`item.colaborador`]="{ item }">
                {{ item.colaborador?.name || "—" }}
              </template>
              <template #[`item.data`]="{ item }">
                {{ formatarData(item.data) }}
              </template>
              <template #[`item.hora`]="{ item }">
                {{ formatarHora(item.hora) }}
              </template>
              <template #[`item.tipo_batida`]="{ item }">
                {{ formatarTipo(item.tipo_batida) }}
              </template>
              <template #[`item.status`]="{ item }">
                <v-chip small :color="corStatus(item.status)" dark>
                  {{ item.status.toUpperCase() }}
                </v-chip>
              </template>
              <template #[`item.aprovador`]="{ item }">
                {{ item.aprovador?.name || "—" }}
              </template>
              <template #[`item.data_aprovacao`]="{ item }">
                {{ formatarDataHora(item.data_aprovacao) }}
              </template>
              <template #[`item.acoes`]="{ item }">
                <v-btn
                  icon
                  small
                  color="primary"
                  title="Ver detalhes"
                  @click.stop="abrirDetalhe(item)"
                >
                  <v-icon small>mdi-eye</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog v-model="dialog" max-width="540" persistent>
      <v-card class="rounded-lg" v-if="selecionada">
        <v-card-title
          class="primary white--text py-3 px-4 d-flex align-center justify-space-between"
        >
          <div class="d-flex align-center">
            <v-icon color="white" class="mr-2">mdi-gavel</v-icon>
            <span class="text-h6 font-weight-bold">Detalhes da Solicitação</span>
          </div>
          <v-chip
            small
            :color="corStatus(selecionada.status)"
            class="font-weight-bold white--text text-capitalize"
          >
            {{ selecionada.status }}
          </v-chip>
        </v-card-title>

        <v-card-text class="pt-4 pb-2 px-4">
          <v-card outlined class="mb-4 grey lighten-5">
            <v-card-text class="py-3">
              <div class="subtitle-1 font-weight-bold primary--text mb-1">
                {{ selecionada.colaborador?.name || "—" }}
              </div>
              <v-row dense class="caption">
                <v-col cols="6"
                  >Data Registro: <strong>{{ formatarData(selecionada.data) }}</strong></v-col
                >
                <v-col cols="6"
                  >Horário:
                  <strong class="primary--text">{{ formatarHora(selecionada.hora) }}</strong></v-col
                >
                <v-col cols="6"
                  >Tipo Registro:
                  <strong>{{ formatarTipo(selecionada.tipo_batida) }}</strong></v-col
                >
                <v-col cols="6"
                  >Solicitado em:
                  <strong>{{ formatarDataHora(selecionada.created_at) }}</strong></v-col
                >
              </v-row>
              <v-divider class="my-2"></v-divider>
              <div class="caption font-weight-bold grey--text">Justificativa Informada:</div>
              <div
                class="body-2 font-italic grey--text text--darken-3 mt-1"
                style="white-space: pre-line"
              >
                "{{ selecionada.justificativa }}"
              </div>
            </v-card-text>
          </v-card>

          <v-card outlined class="mb-3" v-if="selecionada.latitude">
            <v-card-text class="py-2">
              <div class="caption font-weight-bold grey--text">Metadados de Geolocalização:</div>
              <v-row dense class="caption mt-1">
                <v-col cols="6"
                  >Latitude: <strong>{{ selecionada.latitude }}</strong></v-col
                >
                <v-col cols="6"
                  >Longitude: <strong>{{ selecionada.longitude }}</strong></v-col
                >
                <v-col cols="6"
                  >Precisão:
                  <strong>{{
                    selecionada.precisao ? selecionada.precisao + "m" : "—"
                  }}</strong></v-col
                >
                <v-col cols="6"
                  >Capturado em:
                  <strong>{{ formatarDataHora(selecionada.geolocalizacao_at) }}</strong></v-col
                >
                <v-col cols="6"
                  >IP Usuário: <strong>{{ selecionada.ip_address || "—" }}</strong></v-col
                >
                <v-col cols="6"
                  >Dispositivo: <strong>{{ selecionada.device_info || "—" }}</strong></v-col
                >
              </v-row>
              <v-btn
                small
                color="primary"
                outlined
                class="mt-2 font-weight-bold"
                :href="`https://www.google.com/maps/search/?api=1&query=${selecionada.latitude},${selecionada.longitude}`"
                target="_blank"
              >
                <v-icon left small>mdi-google-maps</v-icon>
                Ver no Google Maps
              </v-btn>
            </v-card-text>
          </v-card>

          <v-card outlined class="mb-3 border-left-blue" v-if="selecionada.status !== 'pendente'">
            <v-card-text class="py-2">
              <div class="caption font-weight-bold grey--text">Resultado da Avaliação:</div>
              <v-row dense class="caption mt-1">
                <v-col cols="6"
                  >Avaliado por: <strong>{{ selecionada.aprovador?.name || "—" }}</strong></v-col
                >
                <v-col cols="6"
                  >Avaliado em:
                  <strong>{{ formatarDataHora(selecionada.data_aprovacao) }}</strong></v-col
                >
              </v-row>
              <div
                v-if="selecionada.status === 'rejeitado' && selecionada.motivo_rejeicao"
                class="mt-2"
              >
                <div class="caption font-weight-bold grey--text">Motivo da Rejeição:</div>
                <div class="body-2 font-italic error--text grey lighten-4 pa-2 rounded mt-1 border">
                  "{{ selecionada.motivo_rejeicao }}"
                </div>
              </div>
            </v-card-text>
          </v-card>

          <template v-if="selecionada.status === 'pendente' && modoRejeitar">
            <v-textarea
              v-model="motivoRejeicao"
              label="Motivo da Rejeição *"
              placeholder="Escreva o motivo para rejeitar esta solicitação..."
              outlined
              dense
              rows="3"
              counter="1000"
              :rules="[(v) => !!v || 'Motivo é obrigatório']"
            ></v-textarea>
          </template>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-3 px-4 bg-grey lighten-4">
          <template v-if="selecionada.status === 'pendente'">
            <template v-if="modoRejeitar">
              <v-btn text color="grey" :disabled="avaliando" @click="cancelarRejeitar"
                >Cancelar</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                class="font-weight-bold px-4"
                :loading="avaliando"
                :disabled="!motivoRejeicao || avaliando"
                @click="confirmarRejeitar"
              >
                <v-icon left small>mdi-close</v-icon>
                Confirmar Rejeição
              </v-btn>
            </template>
            <template v-else>
              <v-btn text color="grey" @click="dialog = false">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="error"
                outlined
                class="font-weight-bold mr-2"
                @click="modoRejeitar = true"
              >
                <v-icon left small>mdi-close-circle</v-icon>
                Rejeitar
              </v-btn>
              <v-btn
                color="success"
                class="font-weight-bold px-4"
                :loading="avaliando"
                @click="aprovar"
              >
                <v-icon left small>mdi-check-circle</v-icon>
                Aprovar
              </v-btn>
            </template>
          </template>
          <template v-else>
            <v-spacer></v-spacer>
            <v-btn text color="grey" class="font-weight-bold" @click="dialog = false">Fechar</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main-template>
</template>

<script>
export default {
  name: "GerenciarBatidasRemotasPage",
  data() {
    return {
      aba: 0,
      todas: [],
      carregando: false,
      dialog: false,
      selecionada: null,
      modoRejeitar: false,
      motivoRejeicao: "",
      avaliando: false,
      headersPendentes: [
        { text: "Colaborador", value: "colaborador" },
        { text: "Data", value: "data" },
        { text: "Horário", value: "hora" },
        { text: "Tipo", value: "tipo_batida" },
        { text: "Enviado em", value: "created_at" },
        { text: "", value: "acoes", sortable: false, align: "center", width: "50" },
      ],
      headersHistorico: [
        { text: "Colaborador", value: "colaborador" },
        { text: "Data", value: "data" },
        { text: "Horário", value: "hora" },
        { text: "Tipo", value: "tipo_batida" },
        { text: "Status", value: "status", align: "center" },
        { text: "Avaliador", value: "aprovador" },
        { text: "Avaliado em", value: "data_aprovacao" },
        { text: "", value: "acoes", sortable: false, align: "center", width: "50" },
      ],
    };
  },
  computed: {
    pendentes() {
      return this.todas.filter((b) => b.status === "pendente");
    },
    historico() {
      return this.todas.filter((b) => b.status !== "pendente");
    },
    totalPendentes() {
      return this.pendentes.length;
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      try {
        this.carregando = true;
        this.todas = await this.$services.colaboradorPontosService.adminListarBatidasRemotas();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregando = false;
      }
    },
    abrirDetalhe(item) {
      this.selecionada = item;
      this.modoRejeitar = false;
      this.motivoRejeicao = "";
      this.dialog = true;
    },
    async aprovar() {
      try {
        this.avaliando = true;
        await this.$services.colaboradorPontosService.adminAvaliarBatidaRemota(
          this.selecionada.id,
          {
            status: "aprovado",
          }
        );
        this.$toast.success("Solicitação aprovada com sucesso!");
        this.dialog = false;
        await this.carregar();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.avaliando = false;
      }
    },
    cancelarRejeitar() {
      this.modoRejeitar = false;
      this.motivoRejeicao = "";
    },
    async confirmarRejeitar() {
      if (!this.motivoRejeicao) return;
      try {
        this.avaliando = true;
        await this.$services.colaboradorPontosService.adminAvaliarBatidaRemota(
          this.selecionada.id,
          {
            status: "rejeitado",
            motivo_rejeicao: this.motivoRejeicao,
          }
        );
        this.$toast.success("Solicitação rejeitada com sucesso!");
        this.dialog = false;
        await this.carregar();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.avaliando = false;
      }
    },
    corStatus(status) {
      return { pendente: "orange", aprovado: "green", rejeitado: "red" }[status] || "grey";
    },
    formatarData(data) {
      if (!data) return "—";
      const [ano, mes, dia] = String(data).split("T")[0].split("-");
      return `${dia}/${mes}/${ano}`;
    },
    formatarHora(hora) {
      if (!hora) return "—";
      return String(hora).substring(0, 5);
    },
    formatarTipo(tipo) {
      const map = {
        entrada: "Entrada",
        saida_almoco: "Saída Almoço",
        retorno_almoco: "Retorno Almoço",
        saida: "Saída",
      };
      return map[tipo] || tipo;
    },
    formatarDataHora(data) {
      if (!data) return "—";
      return new Date(data).toLocaleString("pt-BR");
    },
  },
};
</script>

<style scoped>
.cursor-pointer >>> tbody tr {
  cursor: pointer;
}
</style>
